import React from 'react';

const Input = ({ 
  label,
  type = 'text',
  error,
  className = '',
  fullWidth = true,
  ...props 
}) => {
  const inputClasses = `
    w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none 
    focus:ring-2 focus:ring-[#00b894]/20 focus:border-[#00b894] transition-all duration-200
    ${error ? 'border-red-500 focus:ring-red-500/20' : ''}
    ${fullWidth ? 'w-full' : ''}
    min-h-[48px]
    ${className}
  `;
  
  return (
    <div className="space-y-2">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <input
        type={type}
        className={inputClasses}
        {...props}
      />
      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default Input; 